import { connect } from 'react-redux';
import ReactivateUser from '../components/pages/login/ReactivateUser';
import { toJS } from './to-js';
import { reactivateUser } from '../actions/user';

const mapStateToProps = (state) => {
    return {
        user: state.get('user'),
        companyDetails: state.getIn(['company', 'details']),
        reactivateUserState: state.getIn(['user', 'reactivateUser']),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        reactivateUser: (values) => {
            dispatch(reactivateUser(values));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(toJS(ReactivateUser));
